import React from "react";

import styles from "./AnimatedStatsSection.module.scss";
import SectionWrapper from "components/elements/SectionWrapper";

import Card from "components/elements/Card/Card";

const AnimatedStatsSection = (props) => {
    const { alignment, data } = props;
    const alignmentClass = alignment ? `justify-content-${alignment}` : "";
    return (
        <div className={`text-${alignment ? alignment : "left"}`}>
            <SectionWrapper 
                className={`${styles.AnimatedStatsSection}`} 
                fluid={false} 
                {...props}
            >
                <div className={`row ${alignmentClass}`}>
                    {data && data.map((item, index) => (
                        <div className="col-sm-6 col-lg-3 mb-4" key={index}>
                            <Card 
                                title={item.title} 
                                lead={item.short_desc} 
                                desc={item.desc} 
                                cta_text={item.cta_text} 
                                cta_link={item.cta_link} 
                                image={item.image}
                                image_alt={item.image_alt}
                                bg_image={item.bg_image}
                                bg_image_alt={item.bg_image_alt}
                                className={"bg-primary text-white"}
                                count_up={item.number}
                            />
                        </div>
                    ))}
                </div>
            </SectionWrapper>
        </div>
    );
};

export default AnimatedStatsSection;